import { PARTy } from '../../../model/school.model';
import { User, UserToken } from './../../auth/model/user.model';
import { MsgModel } from './../msg/model/msg.model';
import { InputEmailService } from './service/input-email.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, Observable } from 'rxjs';

@Component({
    selector: 'input-email',
    templateUrl: './input-email.component.html',
    styleUrls: ['./input-email.component.scss']
})
export class InputEmailComponent implements OnInit {
    @Input() matLabel: string = 'Email Address';
    @Input() placeholder: string = 'Email Address';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;
    @Input() checkCurrentUser: boolean = true;

    @Input() emailToConfirm: string = '';
    @Output() emailToConfirmChange: EventEmitter<string> = new EventEmitter<string>();

    isLoading: boolean = false;
    msg!: MsgModel;

    myControl: any;
    filteredOptions!: Observable<any>;

    minCharacters: number = 3;

    constructor(private inputEmailService: InputEmailService) {}

    ngOnInit(): void {
        this.myControl = <UntypedFormControl>this.form.get(this.controlName);

        this.filteredOptions = this.myControl.valueChanges.pipe(
            // only search if search string is >= 3 characters
            filter((text: string) => text !== null && text.length >= this.minCharacters && this.validateEmail(text, this.myControl)),
            debounceTime(1000),
            distinctUntilChanged(),
            map((value) => this.checkEmail(value))
        );
    }

    checkEmail(email: any) {
        this.isLoading = true;
        this.inputEmailService
            .checkEmailDomain(email)
            .pipe()
            .subscribe((res) => {
                if (res) {
                    if (res.msg ? res.msg.SUCCESS : false) {
                        let user: UserToken = new UserToken();
                        if (this.checkCurrentUser) {
                            user = JSON.parse(localStorage.getItem('userToken') || '{}') || new User();
                        }

                        this.inputEmailService
                            .emailExists(email, user.user?.PERSON?.PARTy)
                            .pipe()
                            .subscribe((res) => {
                                this.isLoading = false;

                                // Swap success for emailExists
                                // returned value [true === Email already used] => set SUCCESS to false
                                // returned value [false === Email is available] => set SUCCESS to true
                                this.msg = this.swapSuccess(res.msg);
                                this.myControl.setErrors(this.msg.SUCCESS ? null : { emailExists: true });
                            });
                    } else {
                        this.myControl.setErrors({ emailDomain: true });
                        this.msg = res.msg;
                        this.msg.MSG += '. Your email address must be from an education-related domain.';
                        this.isLoading = false;
                    }
                } else {
                    this.myControl.setErrors({ emailDomain: true });
                    this.msg = { MSG: 'The email domain is not valid. Your email address must be from an education-related domain.', SUCCESS: false };
                    this.isLoading = false;
                }

                this.emailToConfirmChange.emit(email);
            });
    }

    validateEmail(email: string, form: UntypedFormControl) {
        const regularExpression =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const isEmail = regularExpression.test(String(email).toLowerCase());

        this.myControl.setErrors(isEmail ? null : { email: true });

        return isEmail;
    }

    swapSuccess(msg: MsgModel) {
        msg.SUCCESS = !msg.SUCCESS;
        return msg;
    }
}
